export default __webpack_public_path__ + "static/media/img-0248-afghanistan-full-face.c527dc31.png";